module.exports = __webpack_public_path__ + "img/blank_orange.8cad2cfc.png";